import 'simplebar-react/dist/simplebar.min.css';
import type SimpleBarCore from 'simplebar-core';
import { styled } from '@mui/material';
import SimpleBar from 'simplebar-react';

const ScrollbarRoot = styled(SimpleBar)``;

export const Scrollbar = ScrollbarRoot;

export type ScrollbarRef = SimpleBarCore;
